<template>
  <div class="calendar">
    <div class="calendar-action">
      <a-button icon="left" size="small" @click="nextWeek"/>
      <div v-if="thisWeekStart === currentWeekStart.date" class="calendar-scope calendar-scope-z"> {{ $t('classSchedule.thisWeek') }} </div>
      <div v-else class="calendar-scope ">{{ currentWeekStart.dateHeader }} - {{ currentWeekEnd.dateHeader }}</div>
      <!-- <div style='margin-top: -3px'>
        
      </div> -->
      <a-button icon="right" size="small" @click="prevWeek"/>
      <div v-if="thisWeekStart !== currentWeekStart.date" class='new_day' @click='nowDay'>
        {{ $t('classSchedule.today') }}
      </div>
    </div>
    <div class="calendar-header">
      <div>{{ $t('classSchedule.monday') }}</div>
      <div>{{ $t('classSchedule.tuesday') }}</div>
      <div>{{ $t('classSchedule.wednesday') }}</div>
      <div>{{ $t('classSchedule.thursday') }}</div>
      <div>{{ $t('classSchedule.friday') }}</div>
      <div>{{ $t('classSchedule.saturday') }}</div>
      <div>{{ $t('classSchedule.sunday') }}</div>
    </div>
    <div class="calendar-content">
      <div v-for="(item, inx) in weekList" :key="inx">
        <div :class="['item', item.ymd === currentYMD ? 'current' : '']" @click="selectDay(item)" >
          {{ item.date }}
        </div>
      </div>
    </div>
    <div class="empty" v-if="arrangeListData.length==0">
      <img src="@/assets/img/pic@2x.png" alt="">
      <div>{{ $t('classSchedule.noArrangement') }}</div>
    </div>
    <div v-else class='arrange'>
      <div class='arrange_wrap'>
        <div v-for="(item, inx) in arrangeListData" :key="inx" class='arrange_item'>
          <div :class='item.status==1 || item.status==3?"arrange_item_left":"arrange_item_left arrange_item_left_g"'></div>
          <div class='top_tit'>
            <div :class='item.status==1 || item.status==3?"":"time"'>{{item.startTime}} - {{item.endTime}}</div>
            <div :class='{"state1":item.status==1,"state2":item.status==2|| item.status==4,"state3":item.status==3}'>{{item.status===1?$t('classSchedule.appointment') : ""}}{{item.status===2?$t('classSchedule.cancelled') : ""}}{{item.status===3?$t('classSchedule.inProgress') : ""}}{{item.status===4?$t('classSchedule.ended') : ""}}</div>
            <div :class='item.status==1 || item.status==3?"remind":"remind remind_g"'></div>
          </div>
          <div :class='item.status==1 || item.status==3?"lessonName":"lessonName lessonName_g"'>
            {{item.lessonName}}
          </div>
          <div :class='item.status==1 || item.status==3?"footer":"footer footer_g"'>
            <div>
              <img v-if='item.status===1 ||  item.status===3' :src='require("@/assets/icons/icon__courser@2x.png")' alt=''>
              <img v-else :src='require("@/assets/icons/icon_r_h@2x.png")' alt=''>
              <span>{{item.className}}</span>
            </div>
            <div>
              <img v-if='item.status===1 ||  item.status===3' :src='require("@/assets/icons/icon_course_dw@2x.png")' alt=''>
              <img v-else :src='require("@/assets/icons/icon_dw_h@2x.png")' alt=''>
              <span>{{item.trainingRoomPlace}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <a-tooltip placement="bottom">
      <template slot="title">
        {{ $t('classSchedule.allSchedule') }}
      </template>
      <span  class="open" @click="open">+</span>
    </a-tooltip>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import moment from 'moment'
import { arrangeList } from '@/api/admin'
let weekStart = dayjs().startOf('week').add(1, 'days')

export default {
  name: 'ClassSchedule',
  data() {
    return {
      thisWeekStart: weekStart.format('MM-DD'),
      currentYMD: dayjs().format('YYYY-M-D'),
      currentWeekStart: {
        dateHeader: weekStart.format('MM.DD'),
        date: weekStart.format('MM-DD'),
        year: weekStart.year(),
        month: weekStart.month() + 1,
        day: weekStart.date()
      },
      currentWeekEnd: {
        dateHeader: weekStart.add(6, 'days').format('MM.DD'),
        date: weekStart.add(6, 'days').format('MM-DD'),
        year: weekStart.add(6, 'days').year(),
        month: weekStart.add(6, 'days').month() + 1,
        day: weekStart.add(6, 'days').date()
      },
      weekList: new Array(7).fill(0).map(() => ({ date: 0, ymd: '' })),
      nowTime:moment(new Date().getTime()).format('YYYY-M-D'),
      page:1,
      pageSize:100,
      arrangeListData:[]
    }
  },

  mounted() {
    this.setWeekList()
    // for(let item of this.weekList){
    //   if(this.isWeekend(item.ymd)){
    //     item.disabled = true
    //   }else{
    //     item.disabled = false
    //   }
    // }
    let params={
      singleDate: this.formatDate(this.currentYMD),
      page:this.page,
      pageSize:this.pageSize
    }
    this.arrangeListHttp(params)
  },
  methods: {
    arrangeList,
    isWeekend(dateString) {
      const date = new Date(dateString);
      const day = date.getDay(); // 0-6, 0是周日
      return day === 6 || day === 0; // 6代表周六
    },
    open(){
     this.$router.push({
       name:'lessonArrange'
      })
    },
    arrangeListHttp(params){
      arrangeList(params).then(res=>{
        if(res.code === 200){

          for(let item of res.data.list){
            item.startTime=item.startTime.substring(11,16)
            item.endTime=item.endTime.substring(11,16)
          }
          this.arrangeListData=res.data.list
        }
      })
    },
    // 回到本周
    nowDay(){
      this.currentWeekStart.date = this.thisWeekStart
      weekStart = dayjs().startOf('week').add(1, 'days')
      this.setCreateDate()
      this.currentYMD=this.nowTime
      let params={
        singleDate: this.formatDate(this.currentYMD),
        page:this.page,
        pageSize:this.pageSize
      }
      this.arrangeListHttp(params)
    },
    // 时间切换
    selectDay(item){
      if(!item.disabled){
        this.currentYMD=item.ymd
        let params={
          singleDate: this.formatDate(this.currentYMD),
          page:this.page,
          pageSize:this.pageSize
        }
        this.arrangeListHttp(params)
      }

    },
    setWeekList() {
      const weekList = this.weekList
      if (this.currentWeekStart.day < this.currentWeekEnd.day) {
        let j = 0
        for (let i = weekList.length; i > 0; i--) {
          weekList[i - 1].date = this.currentWeekEnd.day - j
          weekList[i - 1].ymd = `${this.currentWeekEnd.year}-${this.currentWeekEnd.month}-${weekList[i - 1].date}`
          j++
        }
      } else {
        const middleIndex = 7 - this.currentWeekEnd.day
        let j = 0
        for (let i = weekList.length; i > middleIndex; i--) {
          weekList[i - 1].date = this.currentWeekEnd.day - j
          weekList[i - 1].ymd = `${this.currentWeekEnd.year}-${this.currentWeekEnd.month}-${weekList[i - 1].date}`
          j++
        }
        for (let i = 0; i < middleIndex; i++) {
          weekList[i].date = this.currentWeekStart.day + i
          weekList[i].ymd = `${this.currentWeekStart.year}-${this.currentWeekStart.month}-${weekList[i].date}`
        }
      }
      this.$forceUpdate()
    },
    // 日期格式转化
    formatDate(dateString) {
      const parts = dateString.split('-');
      const year = parts[0];
      let month = parts[1];
      let day = parts[2];

      // 确保月份和日期为两位数
      month = ('0' + month).slice(-2);
      day = ('0' + day).slice(-2);
      return `${year}-${month}-${day}`;
    },
    nextWeek() {
      weekStart = weekStart.subtract(7, 'days')
      this.setCreateDate()
    },
    prevWeek() {
      weekStart = weekStart.add(7, 'days')
      this.setCreateDate()
    },
    setCreateDate() {
      this.currentWeekStart = {
        dateHeader: weekStart.format('MM.DD'),
        date: weekStart.format('MM-DD'),
        year: weekStart.year(),
        month: weekStart.month() + 1,
        day: weekStart.date()
      }
      this.currentWeekEnd = {
        dateHeader: weekStart.add(6, 'days').format('MM.DD'),
        date: weekStart.add(6, 'days').format('MM-DD'),
        year: weekStart.add(6, 'days').year(),
        month: weekStart.add(6, 'days').month() + 1,
        day: weekStart.add(6, 'days').date()
      }
      this.setWeekList()
    }
  }
}
</script>

<style lang="less" scoped>
.calendar {
  height: 100%;
  position: relative;
  .calendar-header {
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    line-height: 32px;
    // background-color: #f8f8f8;
    border-radius: 2px;
    margin: 5px 0;
    font-weight: bold;
    > div {
      flex: 1;
      text-align: center;
      font-size: 10px;
    }
    > div:nth-child(6), > div:nth-child(7) {
      //color: #ADB9C3;
    }
  }
  .calendar-content {
    width: 94%;
    margin: 0 auto;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 18px;
    line-height: 18px;
    > div {
      //flex: 1;
    }
    .item {
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      text-align: center;
      margin: 0 auto;
      background: #F1F1F1;
      &:hover {
        color: #fff;
        background: linear-gradient( 216deg, #FFC480 0%, #FF8B41 100%);
        border-radius: 2px;
        cursor: pointer;
      }
    }
    .item:nth-child(6), .item:nth-child(7) {
      color: #ADB9C3;
    }
    .current {
      color: #fff;
      background: linear-gradient( 216deg, #FFC480 0%, #FF8B41 100%);
      border-radius: 2px;
    }
  }
  .calendar-action {
    display: flex;
    //justify-content: space-between;
    padding: 0 5px;
    align-items: center;
    .calendar-scope {
      font-weight: 500;
      font-size: 12px;
      color: #585858;
      padding: 0 5px;
    }
    .calendar-scope-z{
      font-size: 12px !important;
    }
    .new_day{
      margin-left: 6px;
      min-width: 16px;
      height: 16px;
      line-height: 15px;
      font-size: 9px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #D8DCE0;
      font-weight: 400;
      color: #585858;
      text-align: center;
      cursor: pointer;
      padding: 0 2px;
    }
    /deep/ .ant-btn-sm {
      width: 16px;
      height: 16px;
      line-height: 12px;
      font-size: 9px;
    }
  }
  .open {
    position: absolute;
    right: 1px;
    top: -8px;
    cursor: pointer;
    font-size: 20px;
    color: #646464;
  }
  .open:hover {
    color: #FF6D00;
  }
  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    img {
      width: 98px;
    }
    div {
      font-weight: 500;
      font-size: 12px;
      color: #0D2340;
    }
  }
  .arrange{
    width: 100%;
    margin: 0 auto;
    .arrange_wrap{
      height: 210px;
      width: 96%;
      margin-left: 3%;
      overflow-y: auto;
      background: white;
    }
    .arrange_item{
      background: #F8F7F7;
      border-radius: 2px;
      padding: 8px 9px 0 10px;
      margin-bottom: 10px;
      position: relative;
      .arrange_item_left{
        position: absolute;
        top: 0;
        left: 0;
        width: 2px;
        height: 100%;
        background: #92A0B2;
      }
      .arrange_item_left_g{
        background: #EAEAEA !important;
      }
      .top_tit{
        position: relative;
        display: flex;
        justify-content: space-between;
        .time{
          color: #999999 !important;
        }
        .state1{
          background: #FBEADB;
          color: #FF6D00;
        }
        .state2{
          background: #EBEBEB;
          color: #A3A3A3;
        }
        .state3{
          background: #E2F1EC;
          color: #23B774;
        }
        &>div:nth-child(1){
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }
        &>div:nth-child(2){
          font-weight: 400;
          font-size: 11px;
          height: 19px;
          line-height: 19px;
          border-radius: 12px;
          text-align: center;
          padding: 0 6px;
        }
        .remind{
          position: absolute;
          left: 4px;
          top: 24px;
          width: 11px;
          height: 2px;
          background: #EF623D;
          box-shadow: 0px 0px 10px -2px rgba(133,133,133,0.66);
        }
        .remind_g{
          background: #999999 !important;
        }

      }
      .lessonName{
        font-weight: 500;
        font-size: 14px;
        color: #57626F;
        margin: 15px 0 6px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .lessonName_g{
        color: #999999 !important;
      }
      .footer{
        font-weight: 400;
        font-size: 11px;
        color: #57626F;
        display: flex;
        &>div{
          width: 50%;
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-bottom: 17px;
          img{
            width: 12px;
            height: 12px;
            margin-right: 4px;
          }
          span{
            vertical-align: middle;
          }
        }
      }
      .footer_g{
        color: #999999 !important;
      }
    }
  }
}
.disabled{
  color: #ADB9C3 !important;
  background: none !important;
}
.disabled:hover{
  background: none !important;
  cursor: not-allowed !important;
}
</style>
